export const INGREDIENT_SLOTS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const formatQty = (value) => {
  const num = Number(value);
  if (!num) return '';
  if (Number.isInteger(num)) return String(num);
  return num.toFixed(2).replace(/\.?0+$/, '');
};

export const getRecipeIngredients = (recipe, multiplier = 1) =>
  INGREDIENT_SLOTS
    .map((n) => ({
      slot: n,
      name: String(recipe[`ingediant${n}`] || '').trim(),
      quantity: Number(recipe[`ingediant${n}num`] || 0) * multiplier,
      measurement: recipe[`measurement${n}`] || '',
    }))
    .filter((item) => item.name || item.quantity);

export const formatIngredientLine = (item) => {
  const qty = formatQty(item.quantity);
  return [qty, item.measurement, item.name].filter(Boolean).join(' ').trim();
};

export const getRecipeLineage = (recipe) => {
  const sourceId = Number(recipe?.source_recipe_id);
  if (!sourceId || sourceId === Number(recipe.id)) return null;
  return {
    id: sourceId,
    owner: recipe.source_owner_username || '',
    name: recipe.source_recipiename || '',
  };
};

export const recipeToCreatePayload = (recipe, { name, source } = {}) => {
  const payload = {
    visibility: 'private',
    recipiename: (name || recipe.recipiename || '').trim(),
    notes: recipe.notes || '',
  };
  INGREDIENT_SLOTS.forEach((n) => {
    payload[`ingediant${n}`] = recipe[`ingediant${n}`] || '';
    payload[`ingediant${n}num`] = recipe[`ingediant${n}num`] || 0;
    payload[`measurement${n}`] = recipe[`measurement${n}`] || 'Cups';
  });
  if (source?.id) {
    payload.source_recipe_id = source.id;
    payload.source_owner_username = source.owner || '';
    payload.source_recipiename = source.name || '';
  }
  return payload;
};

export const recipeMatchesSearch = (recipe, term) => {
  if (!term) return true;
  const needle = term.toLowerCase();
  if (recipe.recipiename?.toLowerCase().includes(needle)) return true;
  if (recipe.notes?.toLowerCase().includes(needle)) return true;
  if (recipe.owner_username?.toLowerCase().includes(needle)) return true;
  if (recipe.source_owner_username?.toLowerCase().includes(needle)) return true;
  if (recipe.source_recipiename?.toLowerCase().includes(needle)) return true;
  return getRecipeIngredients(recipe).some((item) =>
    item.name.toLowerCase().includes(needle)
  );
};

export const recipeToClipboardText = (recipe, multiplier = 1) => {
  const lines = getRecipeIngredients(recipe, multiplier).map(
    (item) => `• ${formatIngredientLine(item)}`
  );
  const parts = [recipe.recipiename || 'Recipe'];
  if (lines.length) {
    parts.push('', 'Ingredients:', ...lines);
  }
  if (recipe.notes) {
    parts.push('', 'Notes:', recipe.notes);
  }
  return parts.join('\n');
};
